module.exports = __webpack_public_path__ + "img/0Q3A6963_L_BlackMatted_MockedUp.e54ab012.jpg";